var betaTest = {
  currentVersion: 'alpha',
  alphaSelector: '.cart--alpha',
  betaSelector: '.cart--beta',
  getAlphaVersionItems: () => {
    return document.querySelectorAll(this.alphaSelector);
  },
  getBetaVersionItems: () => {
    return document.querySelectorAll(this.betaSelector);
  },
  show: function show(items) {
    for (i = 0; i < items.length; ++i) {
      items[i].classList.remove('hidden');
    }
  },
  hide: function hide(items) {
    for (i = 0; i < items.length; ++i) {
      items[i].classList.add('hidden');
    }
  },
  showAlphaVersion: () => {
    console.log("SHOW ALPHA VERSION");
    document.querySelector('body').classList.add('cart-alpha-version');
    this.show(this.getAlphaVersionItems());
    this.hide(this.getBetaVersionItems());
    this.currentVersion = 'alpha'
  },
  showBetaVersion: () => {
    document.querySelector('body').classList.add('cart-beta-version');
    betaTest.show(this.getBetaVersionItems());
    betaTest.hide(this.getAlphaVersionItems());
    this.currentVersion = 'beta';
  }
}

/* CART TEST START */

// Show BETA version

// if (document.readyState !== 'loading') {
//     betaTest.showBetaVersion();
// } else {
//   document.addEventListener('DOMContentLoaded', function(event) {
//     betaTest.showBetaVersion();
//   });
// }

// Show Original version

// if (document.readyState !== 'loading') {
//     betaTest.showAlphaVersion();
// } else {
//   document.addEventListener('DOMContentLoaded', function(event) {
//     betaTest.showAlphaVersion();
//   });
// }

/* CART TEST END */

/* PDP TEST START */

// FUNCTION MOVED TO MAIN_PRODUCT.LIQUID FOR EARLY REGISTRATION
// showPDPBetaVersion: () => {
//   document.querySelector('body').classList.add('pdp-beta-version');
// }
// betaTest.showPDPBetaVersion();

/* PDP TEST END */
